import i18n from '../i18n';

const state = {
  type: null,
  message: null
};

const actions = {
  success({ commit }, message) {
    commit('success', message);
  },
  info({ commit }, message) {
    commit('info', message);
  },
  error({ commit }, message) {
    commit('error', message);
  },
  clear({ commit }) {
    commit('clear');
  }
};

const mutations = {
  success(state, message) {
    state.type = 'success';
    state.message = i18n.t(message || 'The operation was successful!');
  },
  info(state, message) {
    state.type = 'info';
    state.message = i18n.t(message);
  },
  error(state, message) {
    state.type = 'error';
    state.message = i18n.t(message || 'An unexpected error occurred, please try again!');
  },
  clear(state) {
    state.message = null;
    state.type = null;
  }
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
};
